import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../utils/getCredentials';
import setPublishBulletin from 'scenes/BulletinBoard/utils/setPublishBulletin';

/**
 * Release a bulletin to the residents without mailing anything.
 *
 * `projectId` is the bulletin's own project — the API checks the permission
 * there and refuses a bulletin that belongs elsewhere — which on a board
 * showing sub-projects too is not always the project on screen.
 */
export const publishBulletin = createAsyncThunk(
  'bulletinBoard/publishBulletin',
  async ({ projectId, bulletinId }) => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const params = {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    };

    const publishedBulletin = await setPublishBulletin(
      projectId,
      bulletinId,
      params
    );

    return { publishedBulletin };
  }
);
